/**
 * Fetch the product-cta section from the server and replace the placeholder
 * section currently on the page.
 */
(function (document) {
  const container = document.querySelector('.product-cta');
  const endpoint = mjpl.productCta ? mjpl.productCta.endpoint : null;
  // If no product-cta container exists or the endpoint could not be found,
  // exit early.
  if (!container || !endpoint) return;

  // Make a request to the endpoint.
  fetch(endpoint, {
    // Include cookies in the request.
    credentials: 'same-origin',
  }).then(response => {
    if (!response.ok) {
      throw new Error(`Received status ${response.status}: “${response.statusText}” for Product CTA request at ${endpoint}.`);
    }
    // The text method returns a Promise.
    return response.text();
  }).then((html) => {
    container.outerHTML = html;
    if (typeof componentEvents !== 'undefined') {
      componentEvents.emitEvent('product-cta-loaded');
      componentEvents.emitEvent('component-init');
    }
  }).catch(console.error); // eslint-disable-line no-console
})(document);
